// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../node_modules/css-loader/index.js!./flag-icon.min.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("b2996462", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/css/flag-icon.min.css
// module id = 656
// module chunks = 0